module.exports = __webpack_public_path__ + "img/GL.41271612.svg";